import React, { useEffect, HtmlHTMLAttributes, useState } from "react";
import { connect } from "react-redux";
import { history } from "../../../../routers/AppRouter";
import { getAlertItems } from "../../../../actions/alert/alert-items";
import styled from 'styled-components';
import MainButton from "../../../../components/MainButton";
import moment from "moment";
import colors from '../../../../styles/colors';
import { getEmailStat } from "../../../../actions/portal/stats-email";
import { EmailContentStatTypes, EmailLeadStat, EmailStatsTypes } from "../stats-types";
import { Link, useParams } from "react-router-dom";
import ABButton from "../../../../components/ABButton";
import { getEMCStat, removeEMCStat } from "../../../../actions/portal/emc-stat";
import FileSelector from "../../../../components/FileSelector";
import { createEMCLeadStat, getEMCLeadStats, removeEMCLeadStat } from "../../../../actions/portal/emc-lead-stat";
import { toast, ToastContainer } from "react-toastify";
import ABSmallButton from "../../../../components/ABSmallButton";
import { sendStatEmail } from "../../../../actions/mail";

const PageWrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px;
`;

const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TableStyle = styled.div`
  padding: 40px 0;
`;

const TableHeading = styled.div`
  display: flex;
`;

const TableRow = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  :hover {
    background: ${colors.gray100};
  }
`;

const TableCellHeading = styled.div`
  padding: 10px;
  width: 125px;
  font-weight: bold;
`;

const TableCell = styled.div`
  padding: 10px;
  width: 125px;
  word-wrap: break-word; /* Ensures long words break and wrap */
  overflow-wrap: anywhere; /* Wraps text even for long URLs or words */
`;

const TableCellHeadingLarge = styled.div`
  padding: 10px;
  width: 300px;
  font-weight: bold;
  word-wrap: break-word;
  overflow-wrap: anywhere;
`;

const TableCellLarge = styled.div`
  padding: 10px;
  width: 300px;
`;

const FilterContainer = styled.div`
  display: flex;
  margin: 20px 0 0 0;
`;

interface FilterButtonProps {
    activeFilterTitle?: boolean;
}

interface StatInfo {
    statType: string;
    contentId: number
    clientId: number
}

const FilterButton = styled.button <FilterButtonProps>`
  background: ${props => props.activeFilterTitle ? colors.blue : colors.white};
  color: ${props => props.activeFilterTitle ? colors.white : colors.black};
  padding: 10px 15px;
  cursor: pointer;
  border: none;
  border-right: 1px solid ${colors.lightGray};
  border-top: 1px solid ${colors.lightGray};
  border-bottom: 1px solid ${colors.lightGray};
  border-left: 1px solid ${colors.lightGray};

  &:nth-child(2), &:last-child {
    border-left: none;
  }
  :hover {
      background-color: ${props => props.activeFilterTitle ? '' : colors.gray100};
  }
`;

const StyledHeading = styled.div`
  padding: 10px 10px 10px 0;
  font-size: 40px;
`;

const SubHeading = styled.div`
  padding: 0;
  font-size: 19px;
  font-weight: bold;
  padding-bottom: 10px;
`;

const Section = styled.div`
  padding: 5px 0;
`;

const Thumbnail = styled.div`
  img {
    width: 75px;
    height: 75px;
  }
`;

const MainImage = styled.div`
  img {
    width: 600px;
  }
`;

const ButtonPadding = styled.div`
  padding: 10px 0;
`;

const DeleteButton = styled.button`
  color: red;
  cursor: pointer;
`;

interface RouteParams {
    id: string;
}

const EmcStatDetails = (props: any) => {

    const [activeFilter, setActiveFilter] = useState('draft');
    const { id } = useParams<RouteParams>();
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    useEffect(() => {
        console.log('id: ', id);

        if (id) {
            props.getEMCStat(id);
            props.getEMCLeadStats(id);
        }
    }, [id]);


    useEffect(() => {
        if (props.deleteLeadSuccess) {
            toast.success("Leads deleted successfully!");
        }
    }, [props.deleteLeadSuccess])

    useEffect(() => {
        if (props.uploadLeadSuccess) {
            toast.success("Leads uploaded successfully!");
            if (id) {
                props.getEMCLeadStats(id); // Refresh leads
            }
        }
    }, [props.uploadLeadSuccess]);

    useEffect(() => {
        if (props.statEmailSuccess) {
            toast.success("Stat update notifcation sent!");
        }
    }, [props.statEmailSuccess])

    useEffect(() => {
        if (props.statEmailError) {
            toast.error("Stat update error!");
        }
    }, [props.statEmailError])

    const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>, title: string) => {
        setActiveFilter(title);
        // if (title === 'all') {
        //     props.getStatsEmail();
        // } else {
        //     props.getStatsEmail({ status: title });
        // }
    }

    const handleFileSelect = (file: File | null) => {
        setSelectedFile(file);
    };

    const handleCSVUpload = () => {
        if (!selectedFile) {
            console.log('No file selected');
            return;
        }
        const formData = new FormData();
        formData.append('csv', selectedFile);
        formData.append('clientId', props.emcStat.clientId);

        props.createEMCLeadStat(formData, id);
    }

    const handeDetailNavigate = () => {

    }

    const handleEdit = () => {
        console.log(props.emcStat.id);
        history.push({
            pathname: `/portal/email-marketing/email-marketing-stats-form/${props.emcStat.id}`,
            state: {
                data: props.emcStat.id,
            },
        });
    };

    const handleDeleteAll = () => {

        const leadIdsToDelete = props.leads.map((lead: EmailLeadStat) => {
            return lead.id;
        })
        console.log(leadIdsToDelete);

        props.removeEMCLeadStat(leadIdsToDelete);
    }

    const handleEMCDelete = () => {
        // console.log('id: ', props.emailStat.id);
        history.push({
            pathname: `../email-marketing/`,
        });
        props.removeEMCStat(id);
    };

    const sendStatNotification = () => {
        // send stat notification with email
        // console.log("client id: ", props.emcStat.clientId);
        const clientInfo = {
            statType: "email-marketing",
            contentId: props.emcStat.id,
            clientId: props.emcStat.clientId
        }
        props.sendStatEmail(clientInfo);
    }

    return (
        <>
            <PageWrapper>
                <div><Link to="../email-marketing">Email Marketing</Link> - Details</div>
                <HeadingContainer>
                    <StyledHeading>Email Marketing Details</StyledHeading>
                    <ABSmallButton onClick={sendStatNotification} title="Send Notification" rounded="true" />
                </HeadingContainer>
                {
                    (props.emcStat && props.emcStat.clientId) &&
                    <div>
                        <Section><MainImage><img src={`https://${props.emcStat.imageUrl}`} /></MainImage></Section>
                        <Section><strong>ID:</strong> {props.emcStat.id}</Section>
                        <Section><strong>Client ID:</strong> {props.emcStat.clientId}</Section>
                        <Section><strong>Newsletter Link:</strong> {props.emcStat.newsletterLink}</Section>
                        <Section>
                            <div><strong>Date:</strong></div>
                            <div>{moment(props.emcStat.alertItem?.date).format('MMM. Do, YYYY')}</div>
                        </Section>
                        <Section>
                            <div><strong>Subject:</strong></div>
                            <div>{props.emcStat.subject}</div>
                        </Section>
                        <Section><strong>Sent:</strong> {props.emcStat.sent.toLocaleString()}</Section>
                        <Section><strong>Delivered:</strong> {props.emcStat.delivered.toLocaleString()}</Section>
                        <Section><strong>Bounce Rate:</strong> {props.emcStat.bounceRate}%</Section>
                        <Section><strong>Open Rate:</strong> {props.emcStat.openRate}%</Section>
                        <Section><strong>Opens:</strong> {props.emcStat.opens.toLocaleString()}</Section>
                        <Section><strong>Clicks:</strong> {props.emcStat.clicks.toLocaleString()}</Section>
                        <Section><strong>CTR:</strong> {props.emcStat.ctr}%</Section>
                        <Section><strong>CTOR:</strong> {props.emcStat.ctor}%</Section>
                        <Section><button onClick={handleEdit}>Edit Stat Details</button></Section>
                        <Section><DeleteButton onClick={handleEMCDelete}>Delete Content Stat</DeleteButton> (Delete all leads first)</Section>

                    </div>
                }

                {
                    id &&
                    <div>
                        <h3>Upload Leads CSV</h3>
                        <FileSelector onFileSelect={handleFileSelect} />
                        {selectedFile && <p><strong>Selected File:</strong> {selectedFile.name}</p>}
                        {
                            selectedFile &&
                            <ButtonPadding>
                                <MainButton onClick={handleCSVUpload} title="Upload" disabled={!selectedFile} />
                            </ButtonPadding>
                        }
                        {
                            props.uploadLeadSuccess &&
                            <div>Upload Succes</div>
                        }
                    </div>
                }

                <DeleteButton onClick={handleDeleteAll}>Delete All Leads</DeleteButton>

                <TableStyle>
                    <SubHeading>Leads for this EMC</SubHeading>

                    <TableHeading>
                        <TableCellHeading>Email</TableCellHeading>
                        <TableCellHeading>First Name</TableCellHeading>
                        <TableCellHeading>Last Name</TableCellHeading>
                        <TableCellHeading>Company</TableCellHeading>
                        <TableCellHeading>Job Title</TableCellHeading>
                        <TableCellHeading>Clicks</TableCellHeading>
                        <TableCellHeading>Priority</TableCellHeading>
                        <TableCellHeading>Link</TableCellHeading>
                    </TableHeading>
                    {
                        (props.leads && props.leads.length > 0) &&
                        props.leads.map((item: EmailLeadStat) => {
                            return (
                                <TableRow key={item.id} onClick={() => handeDetailNavigate()}>
                                    <TableCell>{item.email}</TableCell>
                                    <TableCell>{item.firstName || 'N/A'}</TableCell>
                                    <TableCell>{item.lastName || 'N/A'}</TableCell>
                                    <TableCell>{item.company || 'N/A'}</TableCell>
                                    <TableCell>{item.jobTitle || 'N/A'}</TableCell>
                                    <TableCell>{item.clicks ?? 0}</TableCell>
                                    <TableCell>{item.priority ? '1' : '0'}</TableCell>
                                    <TableCell>
                                        {item.link ? (
                                            <a href={item.link} target="_blank" rel="noopener noreferrer">
                                                Link
                                            </a>
                                        ) : (
                                            'NA'
                                        )}
                                    </TableCell>
                                </TableRow>
                            );
                        })
                    }
                </TableStyle>

                <ToastContainer />
            </PageWrapper>
        </>
    )
}

const mapStateToProps = (state: any) => {
    return {
        emailStat: state.statsEmail.emailStat,
        emcStat: state.emcStats.emcStat,
        leads: state.emcLeadStat.data,
        uploadLeadSuccess: state.emcLeadStat.uploadLeadSuccess,
        deleteLeadSuccess: state.emcLeadStat.deleteSuccess,
        statEmailSuccess: state.statEmailNotification.statEmailSuccess,
        statEmailError: state.statEmailNotification.statEmailError,
    };
};

const mapDispatchToProps = (dispatch: any) => ({
    getEmailStat: (id: string) => dispatch(getEmailStat(id)),
    getEMCLeadStats: (id: string) => dispatch(getEMCLeadStats(id)),
    getEMCStat: (id: string) => dispatch(getEMCStat(id)),
    createEMCLeadStat: (formData: FormData, emcStatId: string) => dispatch(createEMCLeadStat(formData, emcStatId)),
    removeEMCLeadStat: (emcLeadStatIds: Number[]) => dispatch(removeEMCLeadStat(emcLeadStatIds)),
    removeEMCStat: (id: string) => dispatch(removeEMCStat(id)),
    sendStatEmail: (statInfo: StatInfo) => dispatch(sendStatEmail(statInfo))
});

export default connect(mapStateToProps, mapDispatchToProps)(EmcStatDetails);